import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Routes from "./routes";
import './App.css';
import SweetAlert from 'sweetalert-react';
import gql from "graphql-tag";
import { Query } from "react-apollo";
import Loading from './components/Loading';

function isWeChatBroswer() {
  var ua = navigator.userAgent.toLowerCase();
  return ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger' ? true : false;
}



export const GET_ME = gql`
  query getMe{
    me{
      _id
      role
      name
      avatar
    }
  }
`

const getQueryByLocation = (location) => {
  let query = {}
  if (location.search) {
    let pairs = location.search.split('?')[1].split('&')
    let len = pairs.length;
    for (let i = 0; i < len; i++) {
      let keyVals = pairs[i].split('=')
      query[keyVals[0]] = keyVals[1];
    }
  }
  return query;
}

const initAlertState = {
  show: false,
  title: '',
  text: '',
  confirmButtonText: '确定',
  cancelButtonText: '取消',
  showCancelButton: true,
  showConfirmButton: true
}

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLogin: props.me && props.me._id!=='0'? true :false,
      // isAuthenticating: true,
      profile: props.me || '',
      width: 375,
      height: 667,
      query: {},
      errorMsg: '',
      alertState: initAlertState
    };
  }
  async componentDidMount() {
    if (/Android 4\.[0-3]/.test(navigator.appVersion)) {
      window.addEventListener("resize", function () {
        if (document.activeElement.tagName === "INPUT") {
          window.setTimeout(function () {
            document.activeElement.scrollIntoViewIfNeeded();
          }, 0);
        }
      })
    }
    this.setState({
      isWechat: isWeChatBroswer(),
      width: window.innerWidth,
      height: window.innerHeight,
      getFrame: () => {
        return {
          width: window.innerWidth,
          height: window.innerHeight
        }
      },
      query: getQueryByLocation(window.location)
    });
  }
  render() {
    const { ...otherProps } = this.state;
    const self = this;
    const location = {
      ...this.props.location
    }
    let newLocation = {
      ...location,
      query: {}
    }
    if (location.search) {
      let query = {}
      let pairs = location.search.split('?')[1].split('&')
      let len = pairs.length;
      for (let i = 0; i < len; i++) {
        let keyVals = pairs[i].split('=')
        query[keyVals[0]] = decodeURIComponent(keyVals[1]);
      }
      newLocation['query'] = query
    }
    // improve location
    const childProps = {
      ...otherProps,
      location: newLocation,
      updateMe: (isLogin, profile) => {
        this.setState({
          isLogin: isLogin,
          profile: profile
        })
      },
      FlashAlert: (title, type, time) => {
        self.setState({
          alertState: {
            ...self.state.alertState,
            show: true,
            title: title,
            text: '',
            type: type || 'info',
            showCancelButton: false,
            showConfirmButton: false
          }
        })
        setTimeout(() => {
          self.setState({
            alertState: initAlertState
          })
        }, time || 3000)
      },
      Alert: (params) => {
        self.setState({
          alertState: params
        })
      }
    }
    return (
      <div>
        <Routes childProps={childProps} />
        <SweetAlert {...this.state.alertState} />
      </div>
    );
  }
}


class AppWithMe extends React.Component {
  render() {
    const {props} = this;
    return (
    <Query 
      query={GET_ME}
      fetchPolicy="cache-and-network">
      {({ loading, error, data }) => {
        if (loading) return <Loading/>
        if (error) return <div className="palg">加载出错啦，错误是:{error}</div>
        return <App me={data.me} {...props} />
      }}
    </Query>)
  }
}



export default withRouter(AppWithMe);



// WEBPACK FOOTER //
// ./src/App.js